export const SUPPLIER_STATUS = {
    BLOCKED: 'Blocked',
    ACTIVE: 'Active'
};

export const getSupplierDoc = (participatingSuppliersMap: Map, supplierId: number) => {
  return (
    participatingSuppliersMap
    && participatingSuppliersMap.get(supplierId)
  );
}

export const checkIfSupplierIsBlocked = (participatingSuppliersMap: Map, supplierId: number) => {
  const supplierDoc = getSupplierDoc(participatingSuppliersMap, supplierId);
  return supplierDoc && supplierDoc.isBlocked;
}

export const checkIfAwardIsBlocked = (participatingSuppliersMap: Map, supplierId: Number) => {
  const supplierDoc = getSupplierDoc(participatingSuppliersMap, supplierId);
  return supplierDoc && supplierDoc.isBlockedForAward;
}
